import TimePlan from './TimePlan';

export default TimePlan;


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlan/index.js